import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../core/Constants';
import { Helper } from '../shared/helper';

// djb:warn-using sessionStorage is temporary, used to test ui functionality directly in the browser
// for security, this needs to be removed at some point. Ideally, these static methods could be
// refactored to a normal class, then user=new User would provide the related methods as required 

export class User {

  //djb:yagni-static access should not be affected, but worth testing
  private static id = Helper.generateId(1);

  private static _lang: string

  static get lang(): string {
    return this._lang;
  };

  static set lang(value: string) {

    if (value === null) {
      // djb:unknown language provided, set default here
      this._lang = 'en-ca';
    } else {
      this._lang = value.toLowerCase();
    }
  }

  static get sessionCulture(): string {
    return sessionStorage.getItem('currentCulture');
  }

  static validLanguage(): boolean {
    return (this.lang !== 'en-ca' && this.lang !== 'fr-ca')
  }


  static getCurrentCulture(http: HttpClient): string {
    // djb:use session for performance
    this.lang = this.sessionCulture;
    Helper.log("CURRENT CULTURE " + this.sessionCulture);
    if (!this.validLanguage) {
      // djb:note-if session not valid, use api instead
      http.get<{ culture: string }>(`${Constants.API_CMS_ENDPOINT}/translate/currentCulture`)
        .toPromise().then(res => {
          Helper.log("RES.CULTURE " + res.culture);
          sessionStorage.setItem('currentCulture', this.lang);
          this.lang = res.culture;
        });
    }
    return this.lang;
  }

  public static setCurrentCulture(translate: TranslateService, newLang: string): void {
    var langInputValue = (<HTMLInputElement>document.getElementById("lng")).value;
    this.lang = langInputValue;
    this.log(`setCurrentCultre: from ${translate.currentLang} to ${newLang}`)
    sessionStorage.setItem('currentCulture', this.lang.toLowerCase());

    if (this.lang !== translate.currentLang) {
      this.setTranslation(translate);
    }
  }

  static setTranslation(translate: TranslateService): void {
    translate.setDefaultLang(this.lang);
    translate.use(this.lang);
  }

  static get isSummer(): number {
    let isSummer = -1;
    const previousSeason = sessionStorage.getItem("SelectedSeason");
    if (previousSeason !== null) {
      isSummer = Number(previousSeason);
    }
    return isSummer;
  }

  static set isSummer(season: number) {
    sessionStorage.setItem("SelectedSeason", season.toString()); //0 not winter, 1 summer, -1 not set
  }

  static setCustomerID(http: HttpClient): void {
    http.get<{ customer: string, customerGroup: string, showTorontoFirst: string }>(`${Constants.API_CMS_ENDPOINT}/angular/customer`)
      .toPromise().then(res => {
        sessionStorage.setItem("customerID", res.customer);
        sessionStorage.setItem("customerGroupID", res.customerGroup);
        sessionStorage.setItem("showTorontoFirst", res.showTorontoFirst);
      });
  }

  static setPermissionType(http: HttpClient): void {
    http.get<{ permission: string }>(`${Constants.API_CMS_ENDPOINT}/translate/currentCulture/permission`)
      .toPromise().then(res => {
        sessionStorage.setItem("permissionType", res.permission);
      });
  }

  static get permissionType(): string {
    var pt = sessionStorage.getItem("permissionType");
    // djb:if permissionType not available, use empty string (and investigate why it is not set yet)
    if (pt === null) {
      pt = '';
    }
    return pt;
  }

  static removePermissionType(): void {
    sessionStorage.removeItem("permissionType");
  }

  static get isFastcoRole(): boolean {
    return this.permissionType.includes("|fastco");
  }

  static get allowShipFromCalgary(): boolean {
    return this.permissionType.includes("|asc");
  }

  static get enableInternalInventoryTooltip(): boolean {
    return this.permissionType.includes("|itt");
  }

  static get canSplitOrders(): boolean {
    return this.permissionType.includes("|os");
  }

  static get showRetailPrice(): boolean {
    return this.permissionType.includes("|rp");
  }

  static get showDealerPrice(): boolean {
    return this.permissionType.includes("|dp");
  }

  static get showLandedCost(): boolean {
    return this.permissionType.includes("|lc");
  }

  static get showInventory(): boolean {
    return this.permissionType.includes("|iv");
  }

  static get showGVWRGAWR(): boolean {
    //return this.permissionType.includes("|gg") || this.isFasctoRole;
    return this.permissionType.includes("|gg");
  }

  static get showOEMSize(): boolean {
    return this.permissionType.includes("|oe");
  }

  static get showSkipButton(): boolean {
    return this.permissionType.includes("|sk");
  }

  static get showAddCart(): boolean {
    return this.permissionType.includes("|ea");
  }

  static get EnableOEMDataBar(): boolean {
    return this.permissionType.includes("|eo");
  }
  static get EnableAdditionalOEMData(): boolean {
    return this.permissionType.includes("|eao");
  }
  static get EnablePremiumOEMDataBar(): boolean {
    return this.permissionType.includes("|eop");
  }

  static get OEMDataBarPerpetualOpen(): boolean {
    return this.permissionType.includes("|oemp");
  }

  static get ToggleGridView(): boolean {
    return this.permissionType.includes("|gv");
  }

  static get EnableWarningGroup(): boolean {
    return this.permissionType.includes("|wg");
  }

  static get FlagAggressiveSpecs(): boolean {
    return this.permissionType.includes("|as");
  }

  static get EnableSavePackageSummary(): boolean {
    return this.permissionType.includes("|sps");
  }

  public static dispatchEvent(eventName: string, source: string) {
    this.log(source);
    document.dispatchEvent(new Event(eventName));
  }

  static get AllowCustomerFeedback(): boolean {
    return true;
  }

  static get showPackageKit(): boolean {
    return this.permissionType.includes("|spk");
  }

  static get EnableWheelOrTireFirstToggle(): boolean {
    return this.permissionType.includes("|wtt");
  }
  static get getProductPreference(): string {
    if (this.permissionType.includes("|wtt-0")) {
      return "Wheel"
    }
    else if (this.permissionType.includes("|wtt-1")) {
      return "Tire"
    }
    else {
      return "Wheel"
    }
  }

  static get ShowBestFitments(): boolean {
    return this.permissionType.includes("|bf");
  }

  static get WheelOrTireFirstPreference(): string {
    if (this.permissionType.includes("|ptp-0")) {
      return "Wheel";
    }
    else if (this.permissionType.includes("|ptp-1")) {
      return "Tire";
    }
  }
  static get showPricePreference(): boolean {
    return this.permissionType.includes("|pp");
  }
  static get GetPricePreference(): string {
    if (this.permissionType.includes("|price-msrp")) {
      return "msrp";
    }
    else if (this.permissionType.includes("|price-np")) {
      return "np";
    }
    else if (this.permissionType.includes("|price-cpm")) {
      return "cpm";
    }
  }

  static get showVehicleNotes(): boolean {
    return this.permissionType.includes("|vn");
  }

  static get showStanceView(): boolean {
    return this.permissionType.includes("|sv");
  }
  static get ShowInternalNotes(): boolean {
    return this.permissionType.includes("|in");
  }
  static get showRegionToggle(): boolean {
    return this.permissionType.includes("|rt");
  }
  static get getMarginValue(): string {
    const marginSrting = this.permissionType.split('-margin')[0];
    const marginValue = marginSrting.split('|')[marginSrting.split('|').length - 1];
    return marginValue;
  }
  static get showInstallationKitsTab(): boolean {
    return this.permissionType.includes("|ikt");
  }



  //djb:diagnostics specific to this component
  private static log(msg: string) {
    Helper.log(`User[${this.id}].${msg}: `);
  }

}
